function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var l = Object.defineProperty;
var n = Object.getOwnPropertySymbols;
var w = Object.prototype.hasOwnProperty,
    g = Object.prototype.propertyIsEnumerable;

var e = function e(o, t, C) {
  return t in o ? l(o, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: C
  }) : o[t] = C;
},
    i = function i(o, t) {
  for (var C in t || (t = {})) {
    w.call(t, C) && e(o, C, t[C]);
  }

  if (n) {
    var _iterator = _createForOfIteratorHelper(n(t)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var C = _step.value;
        g.call(t, C) && e(o, C, t[C]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return o;
};

import * as r from "react";

function p(o) {
  return r.createElement("svg", i({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o), r.createElement("path", {
    d: "M14.1802 9.86625C14.1802 9.86625 15.1245 4.38125 11.2717 2C11.1556 3.90607 10.223 5.6731 8.70738 6.85875C7.06198 8.2875 3.96735 11.5 4.00026 14.925C3.97615 17.9116 5.66885 20.6534 8.36817 22C8.46368 20.6645 9.09962 19.4233 10.1326 18.5562C11.0078 17.8915 11.576 16.9074 11.7096 15.825C14.0139 17.0348 15.5041 19.3521 15.6333 21.9263V21.9425C18.18 20.7904 19.8566 18.3241 19.9721 15.56C20.2455 12.3425 18.4608 7.9675 16.8774 6.5375C16.2796 7.85556 15.3513 9.00126 14.1802 9.86625Z",
    fill: "black"
  }));
}

export { p as ReactComponent };